import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ROUTES from "../../../../Utils/routesConstants";
import { SearchIcon } from "../../../../Utils/SvgIcons";
import CommonDateRangePicker from "../../CommonComponent/CommonDateRangePicker";
import CustomPagination from "../../../../common/CustomPagination";
import {
  MapView,
  SendEmailWhatsappToProvider,
  initialStateCoverage,
  placeholderSelectColor,
} from "./helper";
import {
  GetAdditionalFilterNetwork,
  getUsageAndCoverageFiltersAction,
  getUsageCoverageDetailsAction,
} from "../../../../redux/actions/NetworkIntelligenceAction";
import { getAllProviderListNetworkAction } from "../../../../redux/actions/TestPackageNetworkAction";
import { API_URL_WITHOUT_USER } from "../../../../Utils/API";
import { getNetworkMenuId, getToken } from "../../../../Utils/types";
import { InputOptionSelect } from "../../../../common/InputOptionSelect";
import WithGoogleApi from "../../../../common/Map/WithGoogleApi";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import { AdditionalFilter } from "./AdditionalFilter";
import { getCityNameAction, getStateNameAction } from "../../../../redux/actions/GlobalAction";

const UsageCoverage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [payload, setPayload] = useState("");
  const [sendType, setSendType] = useState(null);
  const [searchFilter, setSearchFilter] = useState(initialStateCoverage);
  const [serviceValues, setServiceValues] = useState(null);
  const [specialityValues, setSpecialityValues] = useState(null);
  const [providerStatusValues, setProviderStatusValues] = useState(null);
  const [providerValues, setProviderValues] = useState(null);
  const [multiSelect, setMultiSelect] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [inputClient, setInputClient] = useState("");
  const [ibuServices, setIbuServices] = useState("");
  const [provider, setAllProvider] = useState(false);
  const [mapMode, setMapMode] = useState(false);
  const [zoom, setZoom] = useState(8);
  const [minNps,setMinNps] = useState(0);
  const [maxNps,setMaxNps] = useState(100);

  // additional filter hooks 
  const [providerGrade,setProviderGrade] = useState(null)
  const [certificate,setCertificate] = useState(null)
  const [providerType,setProviderType] = useState(null)
  const [qualifaction,setQualifaction] = useState(null)
  const [experience,setExperience] = useState(null)
  const [additionFilter,setAdditionFilter] = useState(false)

  const getUsageCoverageDetails = useSelector(
    (state) => state?.NetworkIntelligenceReducer?.getUsageCoverageDetails
  );
  const getUsageCoverageFilters = useSelector(
    (state) => state?.NetworkIntelligenceReducer?.getUsageCoverageFilters
  );
  const globalReducer = useSelector((state) => state.globalReducer);
  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);

  useEffect(() => {
    dispatch(getAllProviderListNetworkAction());
    dispatch(getUsageAndCoverageFiltersAction("CBU"));
    dispatch(getUsageCoverageDetailsAction(searchFilter));
    dispatch(GetAdditionalFilterNetwork());
    dispatch(getStateNameAction())
  }, []);

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };
useEffect(()=>{
  if (searchFilter?.state) {
    const temp = globalReducer?.getAllState?.filter(
      (ele) => ele?.stateName === searchFilter?.state
    )?.[0]?.stateId;
    dispatch(getCityNameAction(temp));
  }
},[searchFilter?.state])
  const handleSearch = async () => {
    setSearchFilter({ ...searchFilter, page: 1 });
    setAllProvider(false);
    setSelectAll(false);
    setMultiSelect([]);
    if (mapMode === true) {
      setMapMode("other");
      await dispatch(
        getUsageCoverageDetailsAction(
          {
            ...searchFilter,
            page: 1,
            rows: 200,
            maxNPS:maxNps,
            minNPS:minNps,
            providerIds: searchFilter?.providerIds?.toString(),
          },
          "loading"
        )
      );
      setZoom(8);
      setMapMode(true);
    } else {
      dispatch(
        getUsageCoverageDetailsAction({
          ...searchFilter,
          page: 1,
          maxNPS:maxNps,
          minNPS:minNps,
          providerIds: searchFilter?.providerIds?.toString(),
        })
      );
    }
  };
  useEffect(()=>{
    if(mapMode === true){
      dispatch(
       getUsageCoverageDetailsAction(
         {
           ...searchFilter,
           page: 1,
           rows: 200,
           providerIds: searchFilter?.providerIds?.toString(),
         },
         "loading"
       )
     );
    }
 },[mapMode])
  const handleClear = async (value) => {
    setSearchFilter({...initialStateCoverage,BusinessType:value});
    setServiceValues(null);
    setSpecialityValues(null);
    setProviderStatusValues(null);
    setProviderValues(null);
    setProviderGrade(null)
    setQualifaction(null)
    setCertificate(null)
    setProviderType(null)
    setExperience(null)
    setInputClient("");
    setIbuServices("");
    setMultiSelect([]);
    setAllProvider(false);
    setSelectAll(false);
    setMaxNps(100)
    setMinNps(0)
    if (mapMode === true) {
      setMapMode("other");
      const res =  await dispatch(
        getUsageCoverageDetailsAction({
          ...initialStateCoverage,
          page: 1,
          rows: 200,
          BusinessType:value,
          providerIds: searchFilter?.providerIds?.toString(),
        })
      ).then ((res)=>{
        if(res?.data?.results){
          // setZoom(8)
        }
      })
      setMapMode(true)
      
    } else {
      dispatch(getUsageCoverageDetailsAction({...initialStateCoverage,BusinessType:value}));
    }
    
  };

  const downloadFile = (providerId) => {
    setIsLoadingExcel(true);
    const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/GetNetworkUrgencyExportToExcel`;
    const data = {
      ...searchFilter,
      providerIds: provider ? searchFilter.providerIds : providerId,
      rows: 0,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        const filename = "usagecoverage.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
      });
  };
  let appointmentIds;
  if(getUsageCoverageDetails.lenth > 0){
     appointmentIds = getUsageCoverageDetails?.map((ele) => {
      return ele?.providerId;
    });
  } 
 
  const handleSorting = async (type) => {
    changeHandler("SortDirection", type);
    dispatch(
      getUsageCoverageDetailsAction({
        ...searchFilter,
        SortDirection: type,
      })
    );
  };

  return (
    <div className="right-section p-20">
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row pt-3">
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <div className="d-flex justify-content-between">
                  <h4>Search Network </h4>
                  <div class="form-switch mapToggleBtn d-flex">
                    <h6>Map Mode</h6>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      onChange={async(e) => {
                        const res = await dispatch(
                          getUsageCoverageDetailsAction(
                            {
                              ...searchFilter,
                              page: 1,
                              rows: 200,
                              providerIds: searchFilter?.providerIds?.toString(),
                            },
                            "loading"
                          )
                        );
                        if(res){
                          setMapMode(e.target.checked);
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="d-flex flex-wrap gap-10 mt-3">
                  <div className="w-19 my-2">
                    <select
                      className="form-select h-60"
                      value={searchFilter?.BusinessType}
                      onChange={(e) => {
                         handleClear(e.target.value)
                         dispatch(
                          getUsageAndCoverageFiltersAction(e.target.value)
                          );
                      }}
                    >
                      <option value=""> Bussiness Type </option>
                      <option value="IBU">IBU</option>
                      <option value="CBU"> CBU</option>
                    </select>
                  </div>
                  {searchFilter?.BusinessType === "CBU" && (
                    <div className="w-19 my-2">
                      <Select
                        placeholder="Select Services"
                        className="basic-multi-select usagecoverage-search"
                        classNamePrefix="select"
                        isMulti
                        styles={placeholderSelectColor}
                        closeMenuOnSelect={false}
                        name="colors"
                        // inputValue={serviceValues?.input}
                        onInputChange={(value, action) => {
                          if (action.action === "input-change")
                            setServiceValues({
                              ...serviceValues,
                              input: value,
                            });
                        }}
                        onChange={(event) => {
                          changeHandler(
                            "serviceIds",
                            event.map((e) => e.value).toString()
                          );
                          setServiceValues({
                            ...serviceValues,
                            options: event,
                          });
                        }}
                        value={
                          searchFilter?.serviceIds === ""
                            ? null
                            : serviceValues?.options
                        }
                        options={getUsageCoverageFilters?.lstUsageCoverageServices?.map(
                          (ele) => {
                            return {
                              value: ele?.filterId,
                              label: ele?.filterName,
                            };
                          }
                        )}
                        hideSelectedOptions={false}
                        components={{
                          Option: InputOptionSelect,
                        }}
                      />
                    </div>
                  )}
                  {searchFilter?.BusinessType === "IBU" && (
                    <div className="w-19 my-2">
                      <Select
                        placeholder="Select Service"
                        getOptionLabel={(option) => option.filterName}
                        getOptionValue={(option) => option.filterId}
                        className="basic-multi-select usagecoverage-search"
                        classNamePrefix="select"
                        isMulti
                        styles={placeholderSelectColor}
                        closeMenuOnSelect={false}
                        name="colors"
                        onChange={(event) => {
                          let arr = event.map((ele) => {
                            return {
                              testId: ele?.filterId,
                              filterId: ele?.filterId,
                              serviceType: ele?.ordered,
                              filterName: ele?.filterName,
                              ordered: ele?.ordered,
                            };
                          });
                          changeHandler("ibuServices", arr);
                        }}
                        value={
                          searchFilter?.ibuServices === ""
                            ? null
                            : searchFilter?.ibuServices
                        }
                        inputValue={ibuServices}
                        onInputChange={(value, action) => {
                          if (action.action === "input-change")
                            setIbuServices(value);
                        }}
                        options={getUsageCoverageFilters?.lstUsageCoverageServices?.map(
                          (ele) => {
                            return {
                              filterId: ele?.filterId,
                              filterName: ele?.filterName,
                              ordered: ele?.ordered,
                            };
                          }
                        )}
                        hideSelectedOptions={false}
                        components={{
                          Option: InputOptionSelect,
                        }}
                      />
                    </div>
                  )}

                  <div className="w-19 my-2">
                    <Select
                      placeholder="Select Client"
                      getOptionLabel={(option) => option.clientName}
                      getOptionValue={(option) => option.clientId}
                      className="basic-multi-select usagecoverage-search"
                      classNamePrefix="select"
                      isMulti
                      styles={placeholderSelectColor}
                      closeMenuOnSelect={false}
                      name="colors"
                      onChange={(event, i) => {
                        changeHandler("clients", event);
                      }}
                      value={
                        searchFilter?.clients === ""
                          ? null
                          : searchFilter?.clients
                      }
                      inputValue={inputClient}
                      onInputChange={(value, action) => {
                        if (action.action === "input-change")
                          setInputClient(value);
                      }}
                      options={getUsageCoverageFilters?.lstClientModel?.map(
                        (ele) => {
                          return {
                            clientId: ele?.clientId,
                            clientName: ele?.clientName,
                            businessType: ele?.businessType,
                          };
                        }
                      )}
                      hideSelectedOptions={false}
                      components={{
                        Option: InputOptionSelect,
                      }}
                    />
                  </div>
                  <div className="w-19 my-2">
                    <Select
                      placeholder="Doctor Speciality"
                      className="basic-multi-select usagecoverage-search"
                      classNamePrefix="select"
                      isMulti
                      styles={placeholderSelectColor}
                      closeMenuOnSelect={false}
                      name="colors"
                      // inputValue={specialityValues?.input}
                      onInputChange={(value, action) => {
                        if (action.action === "input-change") {
                          setSpecialityValues({
                            ...specialityValues,
                            input: value,
                          });
                        }
                      }}
                      onChange={(event) => {
                        changeHandler(
                          "specialityIds",
                          event.map((e) => e.value).toString()
                        );
                        setSpecialityValues({
                          ...specialityValues,
                          options: event,
                        });
                      }}
                      value={
                        searchFilter?.specialityIds === ""
                          ? null
                          : specialityValues?.options
                      }
                      options={getUsageCoverageFilters?.lstDoctorSpecialty?.map(
                        (ele) => {
                          return {
                            value: ele?.specialtyId,
                            label: ele?.specialtyName,
                          };
                        }
                      )}
                      hideSelectedOptions={false}
                      components={{
                        Option: InputOptionSelect,
                      }}
                    />
                  </div>
                  <div className="w-19 my-2">
                    <Select
                      placeholder="Provider Status"
                      className="basic-multi-select usagecoverage-search"
                      classNamePrefix="select"
                      isMulti
                      // inputValue={providerStatusValues?.input}
                      onInputChange={(value, action) => {
                        if (action.action === "input-change") {
                          setProviderStatusValues({
                            ...providerStatusValues,
                            input: value,
                          });
                        }
                      }}
                      styles={placeholderSelectColor}
                      closeMenuOnSelect={false}
                      name="colors"
                      onChange={(event) => {
                        changeHandler(
                          "ProviderStatusIds",
                          event.map((e) => e.value).toString()
                        );
                        setProviderStatusValues({
                          ...providerStatusValues,
                          options: event,
                        });
                      }}
                      value={
                        searchFilter?.ProviderStatusIds === ""
                          ? null
                          : providerStatusValues?.value
                      }
                      options={getUsageCoverageFilters?.lstProvidersStatus?.map(
                        (ele) => {
                          return {
                            value: ele?.providerStatusId,
                            label: ele?.providerStatusName,
                          };
                        }
                      )}
                      hideSelectedOptions={false}
                      components={{
                        Option: InputOptionSelect,
                      }}
                    />
                  </div>
                  <div className="w-19 my-2">
                    <Select
                      placeholder="Provider Name/Code"
                      className="basic-multi-select usagecoverage-search"
                      classNamePrefix="select"
                      isMulti
                      styles={placeholderSelectColor}
                      closeMenuOnSelect={false}
                      name="colors"
                      inputValue={providerValues?.input}
                      onInputChange={(value, action) => {
                        if (action.action === "input-change") {
                          setProviderValues({
                            ...providerValues,
                            input: value,
                          });
                        }
                      }}
                      onChange={(event) => {
                        changeHandler(
                          "providerIds",
                          event.map((e) => e.value).toString()
                        );
                        setProviderValues({
                          ...providerValues,
                          options: event,
                        });
                      }}
                      value={
                        searchFilter?.providerIds === ""
                          ? null
                          : providerValues?.option
                      }
                      options={TestPackageReducer?.getProviderListNetworkDetails?.map(
                        (ele) => {
                          return {
                            value: ele?.providerId,
                            label: ele?.providerName,
                          };
                        }
                      )}
                      hideSelectedOptions={false}
                      components={{
                        Option: InputOptionSelect,
                      }}
                    />
                  </div>
                  <div className="w-19 my-2">
                    <select
                      className="form-select h-60"
                      value={searchFilter?.visitSupport}
                      onChange={(e) =>
                        changeHandler("visitSupport", e.target.value)
                      }
                    >
                      <option value=""> Visit Type </option>
                      <option value="HV">Home Visit</option>
                      <option value="DC"> Centre Visit</option>
                      <option value="MIX"> Mix Visit</option>
                    </select>
                  </div>
                  <div className="w-19 my-2">
                    <WithGoogleApi>
                      <ReactGoogleAutocomplete
                        className="form-select h-60"
                        apiKey="AIzaSyAy9gYbxqSCIe2BFo46GcNAk81zP-t7ZGA"
                        onPlaceSelected={(place) =>
                          changeHandler(
                            "pincodeOrCity",
                            place.formatted_address
                          )
                        }
                        onChange={(e) => {
                          setSearchFilter({
                            ...searchFilter,
                            pincodeOrCity: e.target.value,
                            distanceInKms: e.target.value?.length ? 10 : 0,
                          });
                        }}
                        value={searchFilter?.pincodeOrCity}
                        types={["geocode", "establishment"]}
                        inputComponent="input"
                        defaultValue={null}
                        placeholder="AreaName/PinCode"
                      />
                    </WithGoogleApi>
                  </div>
                  <div className="w-19 my-2"> 
                  <select
                          name="stateName"
                          value={searchFilter.state}
                          onChange={(e) => {
                            changeHandler("state", e.target.value);
                          }}
                          className="form-select h-60 usagecoverage-search"
                        >
                          <option value="">Select State</option>
                          {globalReducer?.getAllState?.map((ele) => {
                            return (
                              <option value={ele.stateName}>
                                {ele?.stateName}
                              </option>
                            );
                          })}
                        </select>
                  </div>
                  <div className="w-19 my-2"> 
                  <select
                          name="city"
                          value={searchFilter.city}
                          onChange={(e) => {
                            changeHandler("city", e.target.value);
                          }}
                          className="form-select h-60 usagecoverage-search"
                        >
                          <option value="">Select City</option>
                          {globalReducer?.getAllCity?.map((e) => {
                            return (
                              <option key={e.cityName} value={e.cityName}>
                                {e.cityName}
                              </option>
                            );
                          })}
                        </select>
                  </div>
                  {searchFilter?.pincodeOrCity?.length ? (
                    <div className="w-19 my-2">
                      <select
                        className="form-select h-60"
                        value={searchFilter?.distanceInKms}
                        onChange={(e) =>
                          changeHandler("distanceInKms", e.target.value)
                        }
                      >
                        <option value={5}> 5 Kms </option>
                        <option value={10}>10 Kms</option>
                        <option value={15}>15 Kms</option>
                        <option value={20}>20 Kms</option>
                        <option value={30}>30 Kms</option>
                        <option value={40}>40 Kms</option>
                        <option value={50}>50 Kms</option>
                      </select>
                    </div>
                  ) : null}
                </div>
                {mapMode === false && (
                  <div
                    className="d-flex justify-content-between  pt-4"
                    style={{ height: "58px" }}
                  >
                    {getUsageCoverageDetails?.length ? (
                      <h5>
                        <input
                          type="checkbox"
                          onClick={(e) => {
                            e?.target?.checked
                              ? setMultiSelect([
                                  ...new Set(
                                    [
                                      ...multiSelect,
                                      ...getUsageCoverageDetails?.map((ele) => {
                                        return ele?.providerId;
                                      }),
                                    ].map((item) => item)
                                  ),
                                ])
                              : setMultiSelect(
                                  multiSelect?.length === 10
                                    ? []
                                    : multiSelect?.filter(
                                        (item) => !appointmentIds.includes(item)
                                      )
                                );
                            setSelectAll(e.target.checked);
                            setAllProvider(false);
                          }}
                          checked={appointmentIds?.every((r) =>
                            multiSelect?.includes(r)
                          )}
                          className="form-check-input"
                          readOnly
                        />
                        <span className="pt-1"> Select All </span>
                      </h5>
                    ) : null}
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#SendEmailWhatsappToProvider"
                        onClick={() => {
                          setPayload("");
                          setSendType("WhatsApp to Provider");
                          setSearchFilter({ ...searchFilter, page: 1 });
                        }}
                        style={{ border: "none" }}
                        className={`${
                          provider || multiSelect?.length > 0
                            ? ""
                            : "emailWhatsappLogo"
                        }`}
                      >
                        <i className={`fa-brands ${provider || multiSelect?.length > 0
                            ? "fa-whatsapp"
                            : " fa-whatsapp whatsAppDisable"} fa-2x`}></i>
                      </button>
                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#SendEmailWhatsappToProvider"
                        style={{ border: "none" }}
                        className={`${
                          provider || multiSelect?.length > 0
                            ? ""
                            : "emailWhatsappLogo"
                        }`}
                        onClick={() => {
                          setPayload("");
                          setSendType(" Email to Provider");
                          setSearchFilter({ ...searchFilter, page: 1 });
                        }}
                      >
                        <i class={`fa-sharp fa-regular  fa-2x ${provider || multiSelect?.length > 0
                            ? "fa-envelope"
                            : "fa-envelope emailLogo"}`}></i>
                      </button>
                      <div className="w-300 dashbaord-date  ">
                        <CommonDateRangePicker
                          searchFilter={searchFilter}
                          setSearchFilter={setSearchFilter}
                          initialStartDate={new Date().setDate(
                            new Date().getDate() - 15
                          )}
                          initialEndDate={new Date()}
                        />
                      </div>

                      <button
                        className="search"
                        type="button"
                        style={{ border: "none" }}
                        onClick={handleSearch}
                      >
                        <a className="sidebar-links">
                          <SearchIcon />
                          <span className="sidebar-link-text">Search</span>
                        </a>
                      </button>
                      <div
                        className="search"
                        type="button"
                        onClick={()=>handleClear("CBU")}
                      >
                        <a className="sidebar-links">
                          <span className="sidebar-link-text">Clear All</span>
                        </a>
                      </div>

                      <button
                        className={`btn ${
                          !isLoadingExcel ? "search__btn" : "disabled_btn"
                        }`}
                        type="button"
                        onClick={() => {
                          !isLoadingExcel &&
                            downloadFile(multiSelect.toString());
                        }}
                        disabled={!multiSelect?.length}
                      >
                        <i className="fa-solid fa-arrow-down"></i>&nbsp;
                        {isLoadingExcel ? "Exporting..." : "Export To Excel"}
                      </button>
                      <button
                        className="search__btn ascDescBtn"
                        type="button"
                        id="dropdownMenu2"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        &nbsp;
                        <i className="fa fa-list"></i>
                      </button>
                      <button
                        className="setting_config ascDescBtn"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#additionalFilter"
                        aria-controls="offcanvasRight"
                        onClick={() => {
                          setAdditionFilter(true)
                        }}
                      >
                        &nbsp;
                        <i class="fa-solid fa-sliders"></i>
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenu2"
                      >
                        <li>
                          <button
                            className="dropdown-item btn-border-bottom"
                            type="button"
                            onClick={() => handleSorting("asc")}
                          >
                            Ascending Order
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            type="button"
                            onClick={() => handleSorting("desc")}
                          >
                            Descending Order
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {mapMode === true && (
                  <div className="d-flex gap-2 mapModeFilterSearchBtn">
                    <div>
                      <p className="results ">
                        Total <span>{globalReducer?.getTotalCount}</span>{" "}
                        results
                      </p>
                    </div>
                    <div className="d-flex gap-2 ">
                      <div
                        className="search "
                        type="button"
                        onClick={handleSearch}
                      >
                        <a className="sidebar-links">
                          <SearchIcon />
                          <span className="sidebar-link-text">Search</span>
                        </a>
                      </div>
                      <div
                        className="search"
                        type="button"
                        onClick={()=>handleClear("CBU")}
                      >
                        <a className="sidebar-links">
                          <span className="sidebar-link-text">Clear All</span>
                        </a>
                      </div>
                    </div>
                  </div>
                )}
                {mapMode === false && (
                  <div className="d-flex  mt-2 gap-5 ">
                    <div className="me-5 d-flex gap-1">
                      <select
                        className="row-selectdropdown"
                        value={searchFilter?.rows}
                        onChange={(e) => {
                          setSearchFilter({
                            ...searchFilter,
                            page: 1,
                            rows: e.target.value,
                          });
                          dispatch(
                            getUsageCoverageDetailsAction({
                              ...searchFilter,
                              rows: e.target.value,
                              page: 1,
                            })
                          );
                        }}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <p className="results">
                        Total <span>{globalReducer?.getTotalCount}</span>{" "}
                        results
                      </p>
                    </div>
                    <div className="select_all_div  ms-5">
                      {selectAll && provider === false && (
                        <>
                          <p>{multiSelect?.length} providers are selected</p>
                          <span
                            className="select_all_primary_cases"
                            onClick={() => {
                              setAllProvider(true);
                            }}
                            style={{ fontSize: "16px", padding: "0" }}
                          >
                            Select all {globalReducer?.getTotalCount} providers
                          </span>
                        </>
                      )}
                      {provider && (
                        <p className="justify-content-between">
                          {globalReducer?.getTotalCount} providers are selected
                        </p>
                      )}
                    </div>
                  </div>
                )}
                {mapMode === "other" && (
                  <h4 className="mapLoader">
                    Loading Health Assure Network...
                  </h4>
                )}
                {mapMode === false && getUsageCoverageDetails?.length > 0 && (
                  <>
                    {getUsageCoverageDetails?.map((ele, index) => {
                      return (
                        <div className="diagnostic_detailbox" key={index}>
                          <div className="diagnostic_centerbox">
                            <div className="d-flex justify-content-start">
                              <div>
                                <input
                                  type="checkbox"
                                  onClick={(e) =>
                                    e?.target?.checked
                                      ? setMultiSelect([
                                          ...multiSelect,
                                          ele?.providerId,
                                        ])
                                      : setMultiSelect(
                                          multiSelect.filter(
                                            (value) => value !== ele?.providerId
                                          )
                                        )
                                  }
                                  checked={multiSelect?.some(
                                    (element) => element === ele?.providerId
                                  )}
                                  className="form-check-input"
                                  readOnly
                                />
                              </div>
                              <div>
                                <img
                                  style={{ width: "70px", marginRight: "30px" }}
                                  src={ele?.providerLogo}
                                />
                              </div>
                              <div className="w-300">
                                <h5> {ele?.providerName} </h5>
                                <p className="pb-16">{ele?.providerCity}</p>
                                <div
                                  className="progress mb-2"
                                  style={{ visibility: "hidden" }}
                                >
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{
                                      background:
                                        ele?.providerScorePercent >= 0 &&
                                        ele?.providerScorePercent <= 50
                                          ? "linear-gradient(90deg, #ff0101 0%, #ff6b00 100%)"
                                          : ele?.providerScorePercent > 50 &&
                                            ele?.providerScorePercent <= 75
                                          ? "linear-gradient(90deg, #ffb901 0%, #ffe401 100%)"
                                          : "linear-gradient(90deg, #64b161 0%, #31fa2a 100%)",
                                      width: `${ele?.providerScorePercent}%`,
                                    }}
                                    aria-valuenow="50"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  ></div>
                                </div>
                                <p style={{ visibility: "hidden" }}>
                                  <span> {ele?.providerScorePercent}% </span>
                                </p>
                              </div>
                            </div>
                            <div>
                              <h6> Appoinments </h6>
                              <p className="appoinmentn">
                                {ele?.appointmentCount}
                              </p>
                            </div>
                            <div>
                              <h6> Information </h6>
                              <p className="inforn">
                                {ele?.informationScorePercent}%
                              </p>
                            </div>
                            <div>
                              <h6> Diagnostic </h6>
                              <p className="skupkgn">
                                {ele?.skuPackageScorePercent}%
                              </p>
                            </div>
                            {ele?.isDoctorMapped && (
                              <div>
                                <h6> Doctors </h6>
                                <p className="skupkgn">
                                  {ele?.doctorScorePercent}%
                                </p>
                              </div>
                            )}
                            <div>
                              <button
                                className="btn _action__btn"
                                type="button"
                                onClick={() =>
                                  navigate(
                                    `${ROUTES?.PROVIDER_ASSIST}?${ele?.providerId}?${ele?.providerName}`
                                  )
                                }
                              >
                                <i className="fa-regular fa-eye"></i> View
                              </button>
                              <button
                                className="btn _action__btn"
                                type="button"
                                onClick={() =>
                                  downloadFile(ele?.providerId?.toString())
                                }
                                disabled={isLoadingExcel}
                              >
                                <i className="fa-solid fa-file-csv"></i>&nbsp;
                                {isLoadingExcel ? "Exporting..." : "Export"}
                              </button>
                            </div>
                          </div>
                          <div
                            className="contact_btn"
                            style={{ visibility: "hidden" }}
                          >
                            <div>
                              <img src="../images/whatsapp.svg" alt="" />
                              <img src="../images/gmail.svg" alt="" />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
                {mapMode === true && (
                  <div className="rightSideMap">
                    <MapView  setSearchFilter={setSearchFilter}/>
                  </div>
                )}
                {mapMode === false && (
                  <div className="d-flex justify-content-center mt-4">
                    {globalReducer?.getTotalCount !== 0 && (
                      <CustomPagination
                        totalCount={globalReducer?.getTotalCount}
                        perPageData={searchFilter?.rows}
                        searchFilter={searchFilter}
                        setSearchFilter={setSearchFilter}
                        apiCall={getUsageCoverageDetailsAction}
                      />
                    )}
                  </div>
                )}
                <SendEmailWhatsappToProvider
                  sendType={sendType}
                  multiSelect={multiSelect}
                  payload={payload}
                  setPayload={setPayload}
                  searchFilter={searchFilter}
                />
                 <div
                 class="offcanvas offcanvas-end"
                 tabindex="-1"
                 id="additionalFilter"
                 data-bs-backdrop="false"
                 aria-labelledby="offcanvasRightLabel"
                 >
                 {additionFilter === true && 
                  <AdditionalFilter
                  searchFilter={searchFilter}
                  setSearchFilter={setSearchFilter}
                  handleSearch={handleSearch}
                  providerGrade={providerGrade}
                  setProviderGrade={setProviderGrade}
                  certificate={certificate}
                  setCertificate={setCertificate}
                  providerType={providerType}
                  setProviderType={setProviderType}
                  qualifaction={qualifaction}
                  setQualifaction={setQualifaction}
                  experience={experience}
                  setExperience={setExperience}
                  setAdditionFilter={setAdditionFilter}
                  minNps={minNps}
                  maxNps={maxNps}
                  setMinNps={setMinNps}
                  setMaxNps={setMaxNps}
                />
              }
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default UsageCoverage;
